import { createContext, useContext } from "react";
import type { Share, SharedTrip } from "../../src/web/types.ts";

// A shared trip, opened by its view link (features/sharing.md): the trip's own views, read-only, for someone outside
// the trip, from the view's own API (/api/view/<code>, src/sharing/routes.ts) and never the members'. The page is one
// or the other for as long as it's open: opened at /v/<code>, everything it addresses (the views' steps, a file's
// bytes) is the view link's, by its code.

let code: string | null = null;

// This page is a view link's, from now on (ViewPage.tsx, as it opens).
export function startViewing(viewCode: string) {
  code = viewCode;
}

// The view link's code, while this page is one.
export const viewingCode = (): string | null => code;

// Where a file's bytes are: the view's own address on a view link, the members' otherwise.
export const fileHref = (id: string): string =>
  code
    ? `/api/view/${encodeURIComponent(code)}/files/${encodeURIComponent(id)}`
    : `/api/files/${encodeURIComponent(id)}`;

// What the trip's views need to know of the view they're in: who shared it, what's shared (the plan always), and
// who's looking.
export interface ViewingInfo {
  code: string;
  sharedBy: string | null;
  // Tripmo's own sample trip, and how many plan it (the bar: "A sample trip · Planned by four friends …").
  sample: { people: number } | null;
  shares: ReadonlySet<Share>;
  who: SharedTrip["who"];
  viewer: SharedTrip["viewer"];
}

export const Viewing = createContext<ViewingInfo | null>(null);

// The view the trip is in, on a view link; null for a member's own trip.
export function useViewing(): ViewingInfo | null {
  return useContext(Viewing);
}
